// extracted by mini-css-extract-plugin
module.exports = {"bg":"bg-module--bg--3Uu8f"};